import { render, staticRenderFns } from "./gjsz_1.vue?vue&type=template&id=1323501c&scoped=true&"
import script from "./gjsz_1.vue?vue&type=script&lang=js&"
export * from "./gjsz_1.vue?vue&type=script&lang=js&"
import style0 from "./gjsz_1.vue?vue&type=style&index=0&id=1323501c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1323501c",
  null
  
)

export default component.exports